import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2502eb00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm" }
const _hoisted_3 = { class: "login-form__header" }
const _hoisted_4 = {
  key: 1,
  class: "save-cart"
}
const _hoisted_5 = {
  key: 1,
  class: "save-cart__save-message"
}
const _hoisted_6 = {
  key: 0,
  class: "row checkout-page__details-container"
}
const _hoisted_7 = { class: "col-sm-7 position-relative details-column" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 3,
  class: "alternative-delivery"
}
const _hoisted_10 = { class: "switch" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))
const _hoisted_12 = { for: "alternativeDelivery" }
const _hoisted_13 = ["placeholder", "value"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 7,
  class: "message-saved"
}
const _hoisted_16 = { class: "checkout-summary--show-mobile" }
const _hoisted_17 = {
  key: 10,
  class: "delivery-terms"
}
const _hoisted_18 = {
  class: "delivery-terms__label",
  for: "deliveryTerms"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 11,
  class: "summary-container"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "summary-container__errorlist"
}
const _hoisted_24 = { class: "col-md-5 checkout-summary--show-desktop" }
const _hoisted_25 = {
  key: 1,
  class: "container"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "empty-cart" }
const _hoisted_28 = { class: "empty-cart__text" }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 2,
  class: "container"
}
const _hoisted_31 = {
  class: "row",
  style: {"margin-bottom":"500px !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TechnicalError = _resolveComponent("TechnicalError")!
  const _component_CartLoginForm = _resolveComponent("CartLoginForm")!
  const _component_Cart = _resolveComponent("Cart")!
  const _component_SetZipCode = _resolveComponent("SetZipCode")!
  const _component_customer_details_edit = _resolveComponent("customer-details-edit")!
  const _component_box_with_title = _resolveComponent("box-with-title")!
  const _component_customer_details = _resolveComponent("customer-details")!
  const _component_AlternativeDelivery = _resolveComponent("AlternativeDelivery")!
  const _component_AdditionalServices = _resolveComponent("AdditionalServices")!
  const _component_CartSummary = _resolveComponent("CartSummary")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_KlarnaWidget = _resolveComponent("KlarnaWidget")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_ctx.checkout?.basket.numberOfItems && _ctx.checkout?.basket.numberOfItems > 0)
    ? (_openBlock(), _createBlock(_component_v_form, {
        key: 0,
        onSubmit: _ctx.onSubmit,
        class: "checkout-page__container container"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TechnicalError, { ref: "technicalerror" }, null, 512),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.loggedIn)
                ? (_openBlock(), _createBlock(_component_CartLoginForm, {
                    key: 0,
                    registerurl: _ctx.registerurl,
                    forgottenpasswordurl: _ctx.forgottenpasswordurl,
                    selectcompanyurl: _ctx.selectcompanyurl
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("Checkout.LoginToOrder")), 1)
                    ]),
                    _: 1
                  }, 8, ["registerurl", "forgottenpasswordurl", "selectcompanyurl"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Cart, { onUpdateCheckout: _ctx.updateCheckout }, null, 8, ["onUpdateCheckout"]),
              (_ctx.loggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_ctx.loggedIn)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button--base button--primary",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveBasket && _ctx.saveBasket(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.$t("Checkout.SaveBasketButton")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.responseMessage)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.responseMessage), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.checkout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.checkout && !_ctx.loggedIn)
                    ? (_openBlock(), _createBlock(_component_SetZipCode, {
                        key: 0,
                        disabled: _ctx.isLoading,
                        zip: _ctx.checkout.payer.invoiceAddress ? _ctx.checkout.payer.invoiceAddress.zip : '',
                        onUpdated: _ctx.updateZipCode
                      }, null, 8, ["disabled", "zip", "onUpdated"]))
                    : _createCommentVNode("", true),
                  (_ctx.checkout && !_ctx.loggedIn && !_ctx.isKlarnaCheckout  && _ctx.hasDeliveryMethods)
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 1,
                        title: _ctx.$t('Checkout.CustomerDetails')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_customer_details_edit, {
                            title: _ctx.$t('Checkout.Payer'),
                            source: _ctx.checkout.payer,
                            payer: true
                          }, null, 8, ["title", "source"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.checkout && _ctx.loggedIn)
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 2,
                        class: "box-with-title-customer-info",
                        title: _ctx.$t('Checkout.CustomerDetails')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_customer_details, {
                            title: _ctx.$t('Checkout.Payer'),
                            hideData: true,
                            source: _ctx.checkout.payer,
                            payer: true,
                            companyType: _ctx.checkout.payer.company?.companyType,
                            onUpdated: _ctx.updatePayer
                          }, null, 8, ["title", "source", "companyType", "onUpdated"]),
                          (!_ctx.alternativeDelivery)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_8))
                            : _createCommentVNode("", true),
                          (!_ctx.alternativeDelivery && !_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_customer_details, {
                                key: 1,
                                title: _ctx.$t('Checkout.ShipTo'),
                                hideData: true,
                                source: _ctx.checkout.shipTo,
                                shipTo: true,
                                companyType: _ctx.checkout.payer.company?.companyType,
                                companyName: _ctx.checkout.payer.company?.name,
                                onUpdated: _ctx.updateShipTo
                              }, null, 8, ["title", "source", "companyType", "companyName", "onUpdated"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.isResellerSuperUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "alternativeDelivery",
                            id: "alternativeDelivery",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alternativeDelivery) = $event)),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateAlternativeDelivery && _ctx.updateAlternativeDelivery(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.alternativeDelivery]
                          ]),
                          _hoisted_11
                        ]),
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Checkout.AlternativeDelivery")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.alternativeDelivery && _ctx.showPricesAsB2b)
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 4,
                        title: _ctx.$t('Checkout.AlternativeDelivery')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AlternativeDelivery, {
                            isCheckoutPage: true,
                            initialCustomerId: _ctx.initialCustomerId,
                            onSetCustomer: _ctx.updateShipTo,
                            onSetCustomerSaved: _ctx.updateAlternativeDeliverySaved,
                            "onUpdate:modelValue": _ctx.updateShipToComment
                          }, null, 8, ["initialCustomerId", "onSetCustomer", "onSetCustomerSaved", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.checkout && _ctx.hasDeliveryMethods && _ctx.hasAddresses && (!_ctx.hasMatchingZones || _ctx.isContractCustomer))
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 5,
                        title: _ctx.$t('Checkout.MessageLabel')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("textarea", {
                            placeholder: _ctx.$t('Checkout.MessagePlaceholder'),
                            class: "comment-box",
                            "aria-label": "Order comment",
                            maxlength: "249",
                            value: _ctx.orderInformation,
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleTyping && _ctx.handleTyping(...args)))
                          }, null, 40, _hoisted_13)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.loggedIn)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        onClick: [
                          _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","self"])),
                          _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveComment()))
                        ],
                        disabled: _ctx.alternativeDelivery && !_ctx.alternativeDeliverySaved,
                        class: "button--base button--primary save-cart-button"
                      }, _toDisplayString(_ctx.$t('Checkout.SaveComment')), 9, _hoisted_14))
                    : _createCommentVNode("", true),
                  (_ctx.displayResponseMsg)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.responseMessageComment), 1))
                    : _createCommentVNode("", true),
                  (_ctx.hasMatchingZones && _ctx.hasDeliveryMethods && !_ctx.isContractCustomer)
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 8,
                        title: _ctx.$t('Checkout.DeliveryNotPossible'),
                        class: "no-delivery"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Checkout.DeliveryNotPossibleDetails')) + ": " + _toDisplayString(_ctx.matchingProducts.join(', ')), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.checkout && _ctx.checkout?.payer?.company?.companyType !== 'Avtal' && _ctx.checkout?.additionalServices?.length > 0 && _ctx.hasAddresses && !_ctx.hasMatchingZones && _ctx.hasDeliveryMethods)
                    ? (_openBlock(), _createBlock(_component_box_with_title, {
                        key: 9,
                        title: _ctx.$t('Checkout.AdditionalServices')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AdditionalServices, {
                            additionalServices: _ctx.checkout.additionalServices,
                            disabled: _ctx.isLoading,
                            onToggle: _ctx.toggleService
                          }, null, 8, ["additionalServices", "disabled", "onToggle"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.checkout)
                      ? (_openBlock(), _createBlock(_component_CartSummary, {
                          key: 0,
                          serviceItems: _ctx.serviceItems,
                          summary: _ctx.checkout.basket.summary
                        }, null, 8, ["serviceItems", "summary"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.checkout && _ctx.hasAddresses && !_ctx.hasMatchingZones && _ctx.hasDeliveryMethods && !_ctx.isContractCustomer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          required: "",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agreeToDeliveryTerms) = $event)),
                          id: "deliveryTerms"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.agreeToDeliveryTerms]
                        ]),
                        _createElementVNode("label", _hoisted_18, [
                          (_ctx.isBasketBulk)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: _ctx.deliverytermsbulk
                              }, null, 8, _hoisted_19))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: _ctx.deliverytermspall
                              }, null, 8, _hoisted_20))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.checkout && _ctx.hasAddresses && !_ctx.hasMatchingZones && _ctx.hasDeliveryMethods || (_ctx.checkout && _ctx.hasAddresses && _ctx.hasDeliveryMethods && _ctx.isContractCustomer))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (!_ctx.isKlarnaCheckout)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_BaseButton, {
                                type: "submit",
                                class: "summary-container__button button--primary button--base",
                                disabled: (_ctx.isSubmitting || _ctx.alternativeDelivery && !_ctx.alternativeDeliverySaved) || (!_ctx.isContractCustomer && !_ctx.agreeToDeliveryTerms)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("Checkout.PlaceOrder")), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              (_ctx.messages)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (error) => {
                                      return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.checkout)
                    ? (_openBlock(), _createBlock(_component_CartSummary, {
                        key: 0,
                        serviceItems: _ctx.serviceItems,
                        summary: _ctx.checkout.basket.summary
                      }, null, 8, ["serviceItems", "summary"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hasDeliveryMethods && (_ctx.isZipSet || _ctx.loggedIn) && !_ctx.isContractCustomer)
            ? (_openBlock(), _createBlock(_component_box_with_title, {
                key: 1,
                title: _ctx.$t('Checkout.DeliveryNotPossibleUnknownZip'),
                class: "no-delivery"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Checkout.DeliveryNotPossibleUnknownZipDetails')), 1)
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.isKlarnaCheckout && !_ctx.hasMatchingZones && _ctx.agreeToDeliveryTerms)
            ? (_openBlock(), _createBlock(_component_KlarnaWidget, {
                key: 2,
                html: _ctx.checkout && _ctx.checkout.paymentResponse.html,
                isSuspended: _ctx.isLoading
              }, null, 8, ["html", "isSuspended"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit"]))
    : (_ctx.checkout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('Checkout.EmptyCart')), 1),
              _createElementVNode("a", {
                href: _ctx.mainurl,
                class: "button--primary button--base empty-cart__button"
              }, _toDisplayString(_ctx.$t("Checkout.GoToProductPage")), 9, _hoisted_29)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_TechnicalError, { ref: "technicalerror" }, null, 512)
          ])
        ]))
}